/* =========================================================
   SIGNATURE GARDEN PRODUCTS
========================================================= */

const PRODUCTS = [
  {
    name: "Enchanted Forest Throne",
    sku: "EFT-W-RV",
    type: "throne",
    img: "enchanted-forest-throne",
    url: "https://thronekingdom.com/products/enchanted-forest-throne",
    blurb: "Where woodland creatures keep their own court — carved for storybook gardens."
  },
  {
    name: 'King Stag Carved Teak Throne Chair',
    sku: "KSCTTC-36-CO",
    type: "throne",
    img: "king-stag-throne",
    url: "https://thronekingdom.com/products/king-stag-royal-teak-throne-chair",
    blurb: "A carved stag stands sentinel over this rustic woodland throne."
  },
  {
    name: "Royal Lion Teak Garden Throne",
    sku: "RLTGT-ST-TT",
    type: "throne",
    img: "royal-lion-throne",
    url: "https://thronekingdom.com/products/royal-lion-teak-garden-throne",
    blurb: "Lion-head armrests and clawed feet — the boldest seat in the collection."
  },
  {
    name: "Royal Crown Teak Throne Chair",
    sku: "RCTTC-TT",
    type: "throne",
    img: "royal-crown-throne",
    url: "https://thronekingdom.com/products/royal-crown-teak-throne-chair",
    blurb: "Simple, stately, crowned — a throne for every kind of ruler."
  },
  {
    name: "Lioncrest Gothic Garden Throne",
    sku: "LGGT-TT",
    type: "throne",
    img: "lioncrest-throne",
    url: "https://thronekingdom.com/products/lioncrest-gothic-garden-throne",
    blurb: "Cathedral arches and a carved lion crest, cut for quiet drama."
  },
  {
    name: "Tree Of Life Teak Garden Throne",
    sku: "TOLTGT-TT",
    type: "throne",
    img: "tree-of-life-throne",
    url: "https://thronekingdom.com/products/tree-of-life-teak-garden-throne",
    blurb: "A carved Tree of Life anchors this throne in quiet symbolism."
  },
  {
    name: "Sunspire Teak Garden Throne",
    sku: "STGT-TT",
    type: "throne",
    img: "sunspire-throne",
    url: "https://thronekingdom.com/products/sunspire-teak-garden-throne",
    blurb: "A radiant hand-carved sunburst crowns this garden throne."
  },
  {
    name: "Moonspire Teak Garden Throne",
    sku: "MTGT-TT",
    type: "throne",
    img: "moonspire-throne",
    url: "https://thronekingdom.com/products/moonspire-teak-garden-throne",
    blurb: "Crescent moon and scattered stars, carved for evening gardens."
  },
  {
    name: "Royal Peacock Teak Garden Throne",
    sku: "RPTGT-TT",
    type: "throne",
    img: "royal-peacock-throne",
    url: "https://thronekingdom.com/products/royal-peacock-teak-garden-throne",
    blurb: "A fanned peacock tail, carved feather by feather, flanked by regal birds."
  },
  {
    name: "Admiral's Anchor Teak Garden Throne",
    sku: "AATGT-TT",
    type: "throne",
    img: "admirals-anchor-throne",
    url: "https://thronekingdom.com/products/admiral-s-anchor-teak-garden-throne",
    blurb: "A carved anchor for those who hold steady."
  },
  {
    name: "Black Raven Teak Garden Throne",
    sku: "BRTGT-TT",
    type: "throne",
    img: "black-raven-throne",
    url: "https://thronekingdom.com/products/black-raven-teak-garden-throne",
    blurb: "Twin ravens keep watch over a carved crescent moon."
  },
  {
    name: "Lotus Serenity Teak Garden Throne",
    sku: "LSTGT-TT",
    type: "throne",
    img: "lotus-serenity-throne",
    url: "https://thronekingdom.com/products/lotus-serenity-teak-garden-throne",
    blurb: "A blooming lotus rises from carved waves — serenity, seated."
  },

  {
    name: "Admiral's Anchor Teak Garden Bench",
    sku: "AATGB-TB",
    type: "bench",
    img: "admirals-anchor-bench",
    url: "https://thronekingdom.com/products/admiral-s-anchor-teak-garden-bench",
    blurb: "Room for two, anchored in carved teak."
  },
  {
    name: "Royal Peacock Teak Garden Bench",
    sku: "RPTGB-TB",
    type: "bench",
    img: "royal-peacock-bench",
    url: "https://thronekingdom.com/products/royal-peacock-teak-garden-bench",
    blurb: "The peacock's full fan, spread wide enough for two."
  },
  {
    name: "Sunspire Teak Garden Bench",
    sku: "STGB-TB",
    type: "bench",
    img: "sunspire-bench",
    url: "https://thronekingdom.com/products/sunspire-teak-garden-bench",
    blurb: "Sit together beneath a hand-carved sunrise."
  },
  {
    name: "Royal Crown Teak Garden Bench",
    sku: "RCTGB-TB",
    type: "bench",
    img: "royal-crown-bench",
    url: "https://thronekingdom.com/products/royal-crown-teak-garden-bench",
    blurb: "A scalloped crown crest, seating fit for a pair of rulers."
  },
  {
    name: "Tree Of Life Teak Garden Bench",
    sku: "TOLTGB-TB",
    type: "bench",
    img: "tree-of-life-bench",
    url: "https://thronekingdom.com/products/tree-of-life-teak-garden-bench",
    blurb: "Root yourselves together beneath a carved Tree of Life."
  },
  {
    name: "Black Raven Teak Garden Bench",
    sku: "BRTGB-TB",
    type: "bench",
    img: "black-raven-bench",
    url: "https://thronekingdom.com/products/black-raven-teak-garden-bench",
    blurb: "Ravens perched at either end, watching over your garden."
  },
  {
    name: "Royal Lion Teak Garden Bench",
    sku: "RLTGB-TB",
    type: "bench",
    img: "royal-lion-bench",
    url: "https://thronekingdom.com/products/royal-lion-teak-garden-bench",
    blurb: "Lion heads guard both armrests of this regal pair's seat."
  },
  {
    name: "Moonspire Teak Garden Bench",
    sku: "MTGB-TB",
    type: "bench",
    img: "moonspire-bench",
    url: "https://thronekingdom.com/products/moonspire-teak-garden-bench",
    blurb: "Moonlit stars cut clean through carved teak, made for two."
  },
  {
    name: "Lioncrest Gothic Garden Bench",
    sku: "LGGB-TB",
    type: "bench",
    img: "lioncrest-bench",
    url: "https://thronekingdom.com/products/lioncrest-gothic-garden-bench",
    blurb: "Gothic arches and a lion crest, wide enough to share."
  },
  {
    name: "King Stag Carved Teak Garden Bench",
    sku: "KSCTGB-TB",
    type: "bench",
    img: "king-stag-bench",
    url: "https://thronekingdom.com/products/king-stag-carved-teak-garden-bench",
    blurb: "A carved stag watches over this woodland bench for two."
  },
  {
    name: "Lotus Serenity Teak Garden Bench",
    sku: "LSTGB-TB",
    type: "bench",
    img: "lotus-serenity-bench",
    url: "https://thronekingdom.com/products/lotus-serenity-teak-garden-bench",
    blurb: "A carved lotus in bloom, seating for quiet mornings together."
  },
  {
    name: "Enchanted Forest Teak Garden Bench",
    sku: "EFTGB-TB",
    type: "bench",
    img: "enchanted-forest-bench",
    url: "https://thronekingdom.com/products/enchanted-forest-teak-garden-bench",
    blurb: 'Owl, fox, badger, and hare keep watch — "Once Upon a Time," carved into teak.'
  }
];


/* =========================================================
   PRODUCT GRID
========================================================= */

const grid = document.getElementById("productGrid");


/* =========================================================
   PRICE FORMATTING
========================================================= */

function moneyFromCents(cents) {
  return new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
    maximumFractionDigits: 0
  }).format(cents / 100);
}


/* =========================================================
   SHOPIFY LIVE PRICE CACHE
========================================================= */

/*
 * Stores the product-price request so switching between
 * All / Thrones / Benches does not repeatedly request
 * the same Shopify product.
 */
const priceCache = new Map();


/* =========================================================
   FETCH CURRENT SHOPIFY PRODUCT PRICE
========================================================= */

async function fetchProductPrice(product) {
  const handle = product.url
    .split("/products/")[1]
    .split("?")[0]
    .replace(/\/$/, "");

  /*
   * If we've already requested this product during
   * this page visit, reuse the existing request.
   */
  if (priceCache.has(handle)) {
    return priceCache.get(handle);
  }

  const shopRoot =
    window.Shopify &&
    window.Shopify.routes &&
    window.Shopify.routes.root
      ? window.Shopify.routes.root
      : "/";

  const priceRequest = fetch(
    shopRoot + "products/" + handle + ".js"
  )
    .then((response) => {
      if (!response.ok) {
        throw new Error(`Could not load ${handle}`);
      }

      return response.json();
    })
    .then((shopifyProduct) => {
      return {
        price: shopifyProduct.price,
        priceMin: shopifyProduct.price_min,
        priceMax: shopifyProduct.price_max,
        varies: shopifyProduct.price_varies
      };
    })
    .catch((error) => {
      console.error(
        "Price fetch failed:",
        product.name,
        error
      );

      /*
       * Remove failed requests from the cache so a later
       * attempt can try again.
       */
      priceCache.delete(handle);

      return null;
    });

  /*
   * Store the Promise immediately. This also prevents
   * duplicate requests if somebody changes filters while
   * the original request is still loading.
   */
  priceCache.set(handle, priceRequest);

  return priceRequest;
}


/* =========================================================
   RENDER PRODUCTS
========================================================= */

function renderProducts(filter = "all") {
  if (!grid) return;

  grid.innerHTML = "";

  const list =
    filter === "all"
      ? PRODUCTS
      : PRODUCTS.filter(
          (product) => product.type === filter
        );

  list.forEach((product) => {
    const card = document.createElement("div");

    card.className = "product-card reveal in";

    let media;


    /* =====================================================
       PRODUCT IMAGE
    ===================================================== */

    if (
      product.img &&
      window.IMG &&
      window.IMG[product.img]
    ) {
      media = `
        <img
          src="${window.IMG[product.img]}"
          alt="${product.name}"
          loading="lazy"
          decoding="async"
        >
      `;
    } else {
      media = `
        <div class="product-placeholder">

          <svg
            width="30"
            height="30"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="1.5"
            aria-hidden="true"
          >
            <path d="M12 2l2.4 7.4H22l-6 4.4 2.3 7.2L12 16.6 5.7 21l2.3-7.2-6-4.4h7.6z"></path>
          </svg>

          <span>
            Photography Coming Soon
          </span>

        </div>
      `;
    }


    /* =====================================================
       PRODUCT TYPE
    ===================================================== */

    const productTypeLabel =
      product.type === "bench"
        ? "Bench"
        : "Throne";

    const productTypeClass =
      product.type === "bench"
        ? "bench"
        : "";


    /* =====================================================
       PRODUCT CARD HTML
    ===================================================== */

    card.innerHTML = `
      <div class="product-media">

        ${media}

        <span class="product-tag ${productTypeClass}">
          ${productTypeLabel}
        </span>

      </div>


      <div class="product-body">

        <h4>
          ${product.name}
        </h4>

        <p>
          ${product.blurb}
        </p>


        <div class="product-meta">

          <span
            class="product-price"
            aria-live="polite"
          >
            Loading...
          </span>

          <span class="product-sku">
            ${product.sku}
          </span>

        </div>


        <a
          href="${product.url}"
          class="product-cta"
        >
          View Product
        </a>

      </div>
    `;


    /* =====================================================
       ADD CARD TO PAGE
    ===================================================== */

    grid.appendChild(card);


    /* =====================================================
       LOAD CURRENT SHOPIFY PRICE
    ===================================================== */

    const priceElement =
      card.querySelector(".product-price");

    fetchProductPrice(product).then((pricing) => {
      /*
       * The card could have disappeared if the customer
       * changed filters while the request was loading.
       */
      if (
        !priceElement ||
        !document.contains(priceElement)
      ) {
        return;
      }

      if (!pricing) {
        priceElement.textContent =
          "See current price";

        return;
      }

      if (pricing.varies) {
        priceElement.textContent =
          "From " +
          moneyFromCents(pricing.priceMin);
      } else {
        priceElement.textContent =
          moneyFromCents(pricing.price);
      }
    });
  });
}


/* =========================================================
   INITIAL PRODUCT LOAD
========================================================= */

renderProducts("all");


/* =========================================================
   PRODUCT FILTERS
========================================================= */

const filterButtons =
  document.querySelectorAll(".filter-btn");

filterButtons.forEach((button) => {
  button.addEventListener("click", () => {

    filterButtons.forEach((otherButton) => {
      otherButton.classList.remove("active");
    });

    button.classList.add("active");

    renderProducts(
      button.dataset.filter || "all"
    );
  });
});


/* =========================================================
   FAQ
========================================================= */

const FAQS = [
  {
    q: "Are these thrones weather-resistant for outdoor use year-round?",
    a: "Yes, every Signature Garden piece is built from solid teak, a naturally weather and rot-resistant hardwood. Left outdoors without treatment, teak weathers into a silver-grey patina over time. Oiled or sealed regularly, it holds its original warm honey tone for years."
  },

  {
    q: "Where are the Signature Garden pieces made?",
    a: "Each Signature Garden piece is hand-carved from solid teak by skilled local artisans in Indonesia. The detailed carving process takes approximately two months, helping preserve and support the traditional craftsmanship behind every piece."
  },

  {
    q: "Can I customize the finish or size?",
    a: "Many of our thrones and benches can be customized. Call our showroom team at (718) 567-0155 or book a virtual tour to discuss finish, sizing, and any custom requests for your space or event."
  },

  {
    q: "Do you offer financing?",
    a: "Yes, spend up to $5,000 interest-free with no credit needed. Our team can walk you through approval, which typically takes just minutes."
  },

  {
    q: "Do you deliver nationally or just around NYC?",
    a: "Yes. We offer nationwide shipping across the United States. For international or expedited delivery, contact our Brooklyn showroom team for a custom shipping quote."
  },

  {
    q: "Can I rent a throne instead of buying?",
    a: "Yes. We offer rentals for weddings, corporate events, photo shoots and other special occasions across the NYC metro area and we work with trusted rental partners nationwide who carry much of our collection."
  },

  {
    q: "How much do the thrones and benches weigh?",
    a: "Thrones weigh approximately 100lbs with a 450lb weight capacity. Benches weigh approximately 140lbs with a 600lb weight capacity. Allow 1–2 inches of variation across the hand-crafted frame."
  }
];


const faqList =
  document.getElementById("faqList");


if (faqList) {

  FAQS.forEach((faq) => {
    const item =
      document.createElement("div");

    item.className = "faq-item";

    item.innerHTML = `
      <button
        class="faq-q"
        type="button"
        aria-expanded="false"
      >
        <span>
          ${faq.q}
        </span>

        <span
          class="plus"
          aria-hidden="true"
        ></span>
      </button>

      <div class="faq-a">
        <p>
          ${faq.a}
        </p>
      </div>
    `;

    faqList.appendChild(item);
  });


  faqList.addEventListener(
    "click",
    (event) => {

      const button =
        event.target.closest(".faq-q");

      if (!button) return;

      const item =
        button.parentElement;

      const answer =
        item.querySelector(".faq-a");

      const isOpen =
        item.classList.contains("open");


      /* Close any FAQ already open */

      document
        .querySelectorAll(".faq-item.open")
        .forEach((openItem) => {

          openItem.classList.remove("open");

          const openAnswer =
            openItem.querySelector(".faq-a");

          const openButton =
            openItem.querySelector(".faq-q");

          if (openAnswer) {
            openAnswer.style.maxHeight = null;
          }

          if (openButton) {
            openButton.setAttribute(
              "aria-expanded",
              "false"
            );
          }
        });


      /* Open selected FAQ */

      if (!isOpen && answer) {

        item.classList.add("open");

        answer.style.maxHeight =
          answer.scrollHeight +
          40 +
          "px";

        button.setAttribute(
          "aria-expanded",
          "true"
        );
      }
    }
  );
}


/* =========================================================
   REVEAL ON SCROLL
========================================================= */

const revealEls =
  document.querySelectorAll(".reveal");


if ("IntersectionObserver" in window) {

  const observer =
    new IntersectionObserver(
      (entries) => {

        entries.forEach((entry) => {

          if (entry.isIntersecting) {

            entry.target.classList.add("in");

            observer.unobserve(
              entry.target
            );
          }
        });
      },
      {
        threshold: 0.12
      }
    );


  revealEls.forEach((element) => {
    observer.observe(element);
  });

} else {

  /*
   * Fallback for browsers without
   * IntersectionObserver support.
   */

  revealEls.forEach((element) => {
    element.classList.add("in");
  });
}